const tabs = {
    get_started: 'Empezar',
    dashboard: 'Tablero',
    applications: 'Aplicaciones',
    api_resources: 'Recursos de API',
    sign_in_experience: 'Inicio de sesión y cuenta',
    connectors: 'Conectores',
    enterprise_sso: 'SSO empresarial',
    security: 'Seguridad',
    webhooks: 'Webhooks',
    organizations: 'Organizaciones',
    users: 'Gestión de usuarios',
    audit_logs: 'Registros de auditoría',
    roles: 'Roles',
    docs: 'Documentos',
    tenant_settings: 'Configuraciones del inquilino',
    mfa: 'Autenticación multifactor',
    customize_jwt: 'JWT personalizado',
    signing_keys: 'Claves de firma',
    organization_template: 'Plantilla de organización',
};
export default Object.freeze(tabs);
